import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RetailIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_562_1809)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M13.5 14.625H6.06C5.79405 14.6251 5.53657 14.5311 5.33332 14.3594C5.13015 14.1878 4.99432 13.9497 4.95 13.6875L3 2.06243C2.95492 1.795 2.81467 1.55286 2.6052 1.3806C2.39572 1.20833 2.13112 1.11754 1.86 1.12493H1.11",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12.1396 16.8823C12.295 16.8823 12.4209 16.7564 12.4209 16.6011C12.4209 16.4457 12.295 16.3198 12.1396 16.3198",
                        stroke: color || "#676879",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12.1396 16.8823C11.9843 16.8823 11.8584 16.7564 11.8584 16.6011C11.8584 16.4457 11.9843 16.3198 12.1396 16.3198",
                        stroke: color || "#676879",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M6.46094 16.8823C6.61626 16.8823 6.74219 16.7564 6.74219 16.6011C6.74219 16.4457 6.61626 16.3198 6.46094 16.3198",
                        stroke: color || "#676879",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M6.46094 16.8823C6.30561 16.8823 6.17969 16.7564 6.17969 16.6011C6.17969 16.4457 6.30561 16.3198 6.46094 16.3198",
                        stroke: color || "#676879",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M4.4996 11.25H13.5896C14.0872 11.2451 14.5692 11.0753 14.96 10.7672C15.3508 10.4591 15.6285 10.0302 15.7496 9.5475L16.8596 5.1975C16.8785 5.11469 16.8788 5.02874 16.8607 4.94578C16.8425 4.8628 16.8063 4.78486 16.7546 4.7175C16.7022 4.65002 16.6351 4.59537 16.5584 4.55768C16.4818 4.52 16.3975 4.50027 16.3121 4.5H3.3896",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M4.50014 4.50022L7.31264 1.68772C7.57806 1.42483 7.93657 1.27734 8.31014 1.27734C8.68372 1.27734 9.04222 1.42483 9.30764 1.68772L12.1201 4.50022",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.1175 2.50477L13.4175 1.53727C13.5943 1.48451 13.7798 1.46734 13.9632 1.48675C14.1467 1.50616 14.3245 1.56176 14.4863 1.65035C14.6481 1.73893 14.7908 1.85874 14.906 2.00283C15.0212 2.14691 15.1067 2.31242 15.1575 2.48977L15.75 4.49977",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_562_1809",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "matrix(-1 0 0 1 18 0)"
                    })
                })
            })
        ]
    });
